<template>
  <nav class="navbar navbar-expand-lg navbar-fixed">
    <div class="container-fluid">
      <a class="navbar-brand">Cek Invoice</a>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav">
          <drop-down position="right">
            <i slot="title" class="nc-icon nc-bullet-list-67"></i>
            <a href="#" @click="doRemove()" class="dropdown-item text-danger">
              <i class="nc-icon nc-button-power"></i> Keluar
            </a>

          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    methods: {
      doRemove () {
        localStorage.removeItem('telp')
        window.location.href = '/'
      }
    }
  }
</script>

<style>
  .dropdown-notifications .dropdown-menu {
    width: 250px;
  }
</style>


<style scoped>
  .fa5 {
    width: 18px !important;
  }
  .dropdown-notifications .dropdown-item {
    padding: 4px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dropdown-notifications .dropdown-item:last-child {
    border-bottom: 0px;
  }
  .dropdown-notifications .dropdown-item small {
    width: 100%;
    display: block;
    color: #ababab;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/TopNavbar.vue